<template>
  <ul class="list-unstyled articles">
    <TextNoteExtract
      class="n-text-bold"
      type="movement"
      :note="note"
      :key="note.id"
      v-for="note in hierarchy(textNotes)"
    />
  </ul>
</template>
<script>
import artworkDetailsMixin from 'mixins/artworkDetailsMixin.js';
import TextNoteExtract from './TextNoteExtract.vue';

export default {
  name: 'MovementTextNotes',
  props: {
    textNotes: Array,
  },
  components: {
    TextNoteExtract,
  },
  mixins: [artworkDetailsMixin],
  methods: {
    openTextNotesModal() {
      this.$root.$emit('bv::show::modal', 'textNoteModal');
    },
  },
};
</script>
